import { Component, Input } from '@angular/core';
import {fabMenuAnimations} from './fab-menu.animations';

export class FabButton{
  public icon: string = "";
  public label?: string;
  public route?: string;
}

@Component({
  selector: 'app-fab-menu',
  templateUrl: './fab-menu.component.html',
  styleUrls: ['./fab-menu.component.scss'],
  animations: fabMenuAnimations
})
export class FabMenuComponent {
  @Input()
  buttons: FabButton[] = [];

  @Input()
  icon: string = "add";

  displayButtons: FabButton[] = [];
  fabTogglerState: string = 'inactive';

  constructor() { }

  showItems() {
    this.fabTogglerState = 'active';
    this.displayButtons = this.buttons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.displayButtons = [];
  }

  onToggleFab() {
    this.displayButtons.length ? this.hideItems() : this.showItems();
  }
}
